import React from "react";
import {Button} from "../../components/core/Button.jsx";
import {Icon} from "../../components/core/Icon.jsx";
import {Card} from "../../components/core/Card.jsx";
import {Badge} from "../../components/core/Badge.jsx";
import {Tag} from "../../components/core/Tag.jsx";
import {MAX,H1,H2,Reveal,Glitch,Section,Eyebrow,Portrait,Photo} from "./Shell.jsx";

function Hero({go}){
  return (
    <section style={{background:"var(--surface-page)",paddingTop:"clamp(48px,7vw,88px)",paddingBottom:"clamp(64px,9vw,96px)"}}>
      <div className="dp-split" style={{...MAX,gap:"clamp(40px,5vw,64px)",alignItems:"center"}}>
        <div>
          <Eyebrow>Prótesis dental digital · Jerez de la Frontera</Eyebrow>
          <h1 style={{fontSize:H1,marginTop:20,maxWidth:"22ch"}}><Glitch>Laboratorio dental en Jerez. Diseño y produzco tu prótesis en Digital, de principio a fin.</Glitch></h1>
          <p style={{fontSize:"clamp(17px,2vw,20px)",lineHeight:1.45,color:"var(--fg-2)",marginTop:24,maxWidth:"46ch"}}>
            hola, soy Borja Mendoza, llevo más de 10 años como protésico dental. Hoy día, la mayor parte de mi laboratorio funciona digitalmente gracias al CAD/CAM, Escaner e Impresión 3D.
          </p>
          <div className="dp-cta" style={{display:"flex",flexWrap:"wrap",gap:12,marginTop:32}}>
            <Button size="lg" onClick={()=>go("contacto")} iconRight={<Icon name="arrow-right" size={16}/>}>Enviar un caso</Button>
            <Button size="lg" variant="outline" onClick={()=>go("servicios")}>Ver lo que hago</Button>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:"24px 32px",marginTop:48,paddingTop:24,borderTop:"1px solid var(--line-default)"}}>
            {[["+10","años en prótesis"],["100%","flujo digital"],["48 h","casos urgentes"]].map(([n,l])=>(
              <div key={l}><div style={{fontFamily:"var(--font-mono)",fontSize:26,fontWeight:500}}>{n}</div>
              <div style={{fontSize:13,color:"var(--fg-3)",marginTop:2}}>{l}</div></div>
            ))}
          </div>
        </div>
        <div style={{position:"relative"}}>
          <Portrait ratio="4 / 4.4"/>
          <Card style={{position:"absolute",bottom:-28,left:"clamp(-28px,-2vw,0px)",width:"min(270px,78%)",boxShadow:"var(--shadow-pop)"}} pad="sm">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontFamily:"var(--font-mono)",fontSize:12,color:"var(--fg-2)"}}>caso 2026-0418</span>
              <Badge tone="success" dot>En impresión</Badge>
            </div>
            <div style={{fontFamily:"var(--font-display)",fontWeight:700,fontSize:17,marginTop:10}}>Corona 26 · zirconio</div>
            <div style={{display:"flex",gap:6,marginTop:12}}>
              {[0,1,2,3].map(i=><div key={i} style={{flex:1,height:4,background:i<3?"var(--cyan-500)":"var(--neutral-200)"}}/>)}
            </div>
            <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--fg-3)",marginTop:8}}>escaneo → diseño → producción → envío</div>
          </Card>
        </div>
      </div>
    </section>
  );
}

const SERVICES=[
  ["layers","Coronas y puentes","Zirconio multicapa y disilicato, fresado y acabado en el laboratorio."],
  ["scan-line","Escaneo e impresión 3D","Modelos, férulas y guías quirúrgicas impresas en resina."],
  ["pencil-ruler","Diseño CAD","Diseño del caso en exocad y validación contigo antes de producir."],
  ["shield","Férulas","Férulas de descarga diseñadas y producidas con flujo digital."],
  ["anchor","Implantología","Estructuras atornilladas y barras sobre implante."],
  ["bot","Agentes de IA","Automatizo el papeleo y los avisos para no perder tiempo en el ordenador."]
];

function Services({go}){
  return (
    <Section tone="card">
      <div style={{display:"flex",flexWrap:"wrap",alignItems:"flex-end",justifyContent:"space-between",gap:"24px 40px"}}>
        <Reveal><Eyebrow>Servicios</Eyebrow><h2 style={{fontSize:H2,marginTop:16,maxWidth:"22ch"}}><Glitch>Todo el caso en el mismo sitio</Glitch></h2></Reveal>
        <div style={{maxWidth:"42ch"}}>
          <p style={{fontSize:16,lineHeight:1.62,color:"var(--fg-2)"}}>No subcontrato el diseño. Recibo el escaneo, lo diseño, lo produzco y lo reviso antes de enviarlo.</p>
          <p style={{fontSize:16,lineHeight:1.62,color:"var(--fg-2)",marginTop:12}}>Trabajo para clínicas de Jerez y de toda la provincia de Cádiz, y para cualquier clínica de España por mensajería.</p>
        </div>
      </div>
      <div className="dp-g3" style={{gap:1,marginTop:48,background:"var(--line-default)",border:"1px solid var(--line-default)",borderRadius:"var(--radius-3)",overflow:"hidden"}}>
        {SERVICES.map(([icon,t,d],n)=>(
          <Reveal key={t} delay={n*70} style={{background:"var(--surface-card)",padding:28}}>
            <span style={{color:"var(--cyan-700)"}}><Icon name={icon} size={22} strokeAlign="middle"/></span>
            <h4 style={{marginTop:16}}>{t}</h4>
            <p style={{fontSize:14,lineHeight:1.6,color:"var(--fg-2)",marginTop:8}}>{d}</p>
          </Reveal>
        ))}
      </div>
      <div style={{marginTop:32}}><Button variant="outline" onClick={()=>go("servicios")}>Ver materiales y plazos</Button></div>
    </Section>
  );
}

const FLOW=[
  ["01","Recibo el escaneo","STL o archivo del intraoral, por el canal que uses."],
  ["02","Diseño en CAD","Te enseño el diseño y lo ajustamos si hace falta."],
  ["03","Produzco","Fresado o impresión 3D, sinterizado y acabado a mano."],
  ["04","Envío y seguimiento","Sale con albarán y te aviso del estado en cada paso."]
];

function Flow(){
  return (
    <Section>
      <Reveal><Eyebrow>Flujo digital</Eyebrow>
      <h2 style={{fontSize:H2,marginTop:16,maxWidth:"20ch"}}><Glitch>Cuatro pasos, sin sorpresas</Glitch></h2></Reveal>
      <div className="dp-g4" style={{gap:24,marginTop:48}}>
        {FLOW.map(([n,t,d],i)=>(
          <Reveal key={n} delay={i*90} style={{borderTop:"2px solid var(--teal-900)",paddingTop:16}}>
            <div style={{fontFamily:"var(--font-mono)",fontSize:12,color:"var(--cyan-700)"}}>{n}</div>
            <h4 style={{marginTop:10}}>{t}</h4>
            <p style={{fontSize:14,lineHeight:1.6,color:"var(--fg-2)",marginTop:8}}>{d}</p>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

function AgentsTeaser({go}){
  return (
    <Section tone="brand">
      <div className="dp-g2" style={{gap:"clamp(40px,5vw,64px)",alignItems:"center"}}>
        <div>
          <Reveal><Eyebrow invert>Para otros laboratorios</Eyebrow>
          <h2 style={{fontSize:H2,marginTop:16,color:"#fff",maxWidth:"20ch"}}>Los <Glitch>Agentes</Glitch> hacen el papeleo. Yo hago <Glitch>Prótesis</Glitch>.</h2></Reveal>
          <p style={{fontSize:18,lineHeight:1.55,color:"var(--neutral-200)",marginTop:20,maxWidth:"44ch"}}>
            Monté agentes que reciben los STL, los preparan para imprimir, avisan a la clínica y me dejan el albarán hecho. Si tienes un laboratorio pequeño, te cuento cómo montarlo.
          </p>
          <div className="dp-cta" style={{display:"flex",flexWrap:"wrap",gap:12,marginTop:28}}>
            <Button variant="accent" size="lg" onClick={()=>go("agentes")}>Cómo lo hago</Button>
            <Button variant="outline" size="lg" style={{borderColor:"rgba(255,255,255,.4)",color:"#fff"}} onClick={()=>go("contacto")}>Hablar con Borja</Button>
          </div>
        </div>
        <div style={{background:"rgba(255,255,255,.05)",border:"1px solid var(--line-on-brand)",borderRadius:"var(--radius-3)",padding:24}}>
          {[["inbox","STL recibido de la clínica","hace 2 min"],["layers","Laminado automático","42 s"],["printer","Enviado a Photon M7","en cola"],["send","Aviso a la clínica","pendiente"]].map(([ic,t,meta],i)=>(
            <div key={t} style={{display:"flex",alignItems:"center",gap:14,padding:"14px 0",borderBottom:i<3?"1px solid var(--line-on-brand)":"none"}}>
              <span style={{color:"var(--cyan-400)"}}><Icon name={ic} size={18} strokeAlign="middle"/></span>
              <span style={{flex:1,fontSize:15,color:"#fff"}}>{t}</span>
              <span style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--neutral-400)"}}>{meta}</span>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

function Cases({go}){
  return (
    <Section tone="card">
      <div style={{display:"flex",flexWrap:"wrap",gap:"20px 24px",justifyContent:"space-between",alignItems:"flex-end"}}>
        <Reveal><Eyebrow>Casos</Eyebrow><h2 style={{fontSize:H2,marginTop:16}}><Glitch>Trabajo reciente</Glitch></h2></Reveal>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}><Tag selected>Todos</Tag><Tag>Zirconio</Tag><Tag>Impresión</Tag><Tag>Implantes</Tag></div>
      </div>
      <div className="dp-g3" style={{gap:24,marginTop:40}}>
        {[
          ["Rehabilitación superior","14 unidades · zirconio","/assets/caso-molar-zirconio.jpg","Modelo digital de la arcada escaneada en oclusión"],
          ["Férula de descarga","impresión 3D · resina","/assets/caso-ferula-descarga.jpg","Férula de descarga con marcas de oclusión"],
          ["Estructura atornillada","6 implantes · Cr-Co","/assets/caso-estructura-atornillada.jpg","Estructura atornillada sobre implantes"]
        ].map(([t,m,src,alt],n)=>(
          <Reveal key={t} delay={n*70}>
            <Photo src={src} alt={alt} ratio="16 / 11" fit="contain"/>
            <h4 style={{marginTop:14}}>{t}</h4>
            <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--fg-3)",marginTop:4}}>{m}</div>
          </Reveal>
        ))}
      </div>
      <div style={{marginTop:32}}><Button variant="outline" onClick={()=>go("casos")}>Ver todos los casos</Button></div>
    </Section>
  );
}

function ClosingCTA({go}){
  return (
    <Section style={{background:"var(--surface-page)"}}>
      <div style={{border:"1px solid var(--line-ink)",borderRadius:"var(--radius-5)",padding:"clamp(32px,5vw,56px) clamp(24px,4vw,48px)",display:"flex",flexWrap:"wrap",alignItems:"center",justifyContent:"space-between",gap:"32px 40px"}}>
        <Reveal><h2 style={{fontSize:H2,maxWidth:"24ch"}}>¿Tienes un caso? <Glitch>Mándalo</Glitch> y te contesto <Glitch>hoy</Glitch>.</h2>
          <p style={{fontSize:17,color:"var(--fg-2)",marginTop:14,maxWidth:"48ch"}}>Sin formularios eternos: el archivo, la clínica y qué necesitas.</p></Reveal>
        <Button size="lg" variant="accent" onClick={()=>go("contacto")} iconRight={<Icon name="arrow-right" size={16}/>}>Enviar un caso</Button>
      </div>
    </Section>
  );
}

export function HomeScreen({go}){
  return <>
    <Hero go={go}/><Services go={go}/><Flow/><AgentsTeaser go={go}/><Cases go={go}/><ClosingCTA go={go}/>
  </>;
}
